export default "__VITE_ASSET__CSQVJHlN__"